// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2V6t4","sendOtp":"AuthorizeToLogin_sendOtp__RyvRp"};